import { type Static } from '@sinclair/typebox';
import { ListResponseSchema } from '../../shared/utils/list-response.schema';
import { inboxSchema } from './inbox.schema';

export const GetInboxesListResponseSchema = ListResponseSchema(inboxSchema);

export type GetInboxesListResponse = Static<typeof GetInboxesListResponseSchema>;
